export {default} from 'views/IbAccountRules/IbAccountRules'



// WEBPACK FOOTER //
// ./src/views/Administration/IbAccountRules.jsx